import { wrapApiCall } from '@/lib/axios'
import type { AxiosInstance } from 'axios'
import { deserialize } from 'ts-jackson'
import { DocumentListResponse, DocusignResponse } from './model'

export const DocusignService = (client: AxiosInstance) => {
  return {
    async signAgreement(userId: number, redirectUrl: string): Promise<DocusignResponse> {
      const { data } = await wrapApiCall(() =>
        client.post<DocusignResponse>('/docusign/agreement', { userId, redirectUrl })
      )
      return data
    },
    async signParQ(userId: number, redirectUrl: string): Promise<DocusignResponse> {
      const { data } = await wrapApiCall(() =>
        client.post<DocusignResponse>('/docusign/par-q', { userId, redirectUrl })
      )
      return data
    },
    async signAll(userId: number, redirectUrl: string): Promise<DocusignResponse> {
      const { data } = await wrapApiCall(() =>
        client.post<DocusignResponse>('/docusign/all', { userId, redirectUrl })
      )
      return data
    },
    async getDocumentList(userId: number): Promise<DocumentListResponse[]> {
      const { data } = await wrapApiCall(() =>
        client.get<Record<string, unknown>[]>('/docusign/list', { params: { userId } })
      )
      return data?.map((item: Record<string, unknown>) => deserialize(item, DocumentListResponse))
    },
    async deleteDocument(envelopeId: number | string): Promise<void> {
      await wrapApiCall(() => client.delete(`/docusign/${envelopeId}`))
    },
  }
}
